module.exports = __webpack_public_path__ + "img/finance_1.cdec51e5.png";